<dx-box
    width="100%"
    height="100%"
    direction="col"
    class="cc-data-grid-feature"
    [ngClass]="{ 'cc-data-grid-fullscreen dx-theme-background-color dx-theme-border-color': isInFullScreen }"
>
    <dxi-item [baseSize]="!useRatio ? 'auto' : undefined" [ratio]="useRatio ? 1 : undefined">
        <ng-content></ng-content>
    </dxi-item>
    <dxi-item [baseSize]="4" [visible]="pagingConfig?.visible"></dxi-item>
    <dxi-item [baseSize]="32" [visible]="pagingConfig?.visible">
        <cc-data-grid-pager
            [hasGrouping]="hasGrouping"
            [dataSource]="dataSource"
            [dataGrid]="grid"
            [pagingConfig]="pagingConfig"
            [toolbarItems]="pagingConfig?.toolbarItems"
        ></cc-data-grid-pager>
    </dxi-item>
</dx-box>
